import { attendeeConstants } from "../../../constants/attendee/attendee.constants";

export function attendee(state = { activePersonNo: 0 }, action) {
  switch (action.type) {
    case attendeeConstants.GET_ATTENDEE_LIST_REQUEST:
      return { ...state, loading: true };

    case attendeeConstants.GET_ATTENDEE_LIST_SUCCESS:
      if (action && !action.orderList) {
        action.orderList = [{}];
      }
      if (action && action.orderList && action.orderList.length === 0) {
        action.orderList.push({});
      }
      return { ...state, loading: false, orders: action.orderList };

    case attendeeConstants.GET_ATTENDEE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case attendeeConstants.REMOVE_ORDER:
      var newOrderList = Array.from(state.orders);
      var newActivePersonNo = 0;

      if (state.orders.length > 1) {
        const orderToRemove = newOrderList[action.activePersonNo];

        const index = newOrderList.indexOf(orderToRemove);
        if (index > -1) {
          newOrderList.splice(index, 1);
        }
        /*   newOrderList = newOrderList.slice()  (action.activePersonNo, 1); */

        if (newOrderList.length == 1) {
          newActivePersonNo = 0;
          state.orders[0].leader = true;
        } else if (newActivePersonNo > 0 && newOrderList.length > 1) {
          newActivePersonNo = state.activePersonNo - 1;
          if (state.orders[action.activePersonNo].leader == true) {
            state.orders[action.activePersonNo - 1].leader = true;
          }
        }
      }

      return {
        ...state,
        orders: newOrderList,
        activePersonNo: newActivePersonNo,
      };
    case attendeeConstants.SET_LEADER:
      var newOrderList = Array.from(state.orders);
      newOrderList = newOrderList.map((n, i) => {
        n.leader = false;
        if (i == action.activePersonNo) {
          n.leader = true;
        }
        return n;
      });
      return {
        ...state,
        orders: newOrderList,
      };

    case attendeeConstants.SET_ACTIVE_PERSON_NO:
      console.log("setting");
      return {
        ...state,
        activePersonNo: action.activePersonNo,
      };

    case attendeeConstants.CREATE_ORDER:
      var newOrderList = Array.from(state.orders);
      newOrderList.push(action.newOrder);
      if (state.orders.length == 1) {
        state.orders[0].leader = true;
      }
      return { ...state, orders: newOrderList, activePersonNo: newOrderList.length - 1 };

    case attendeeConstants.UPDATE_ORDER:
      var updatedOrderList = Array.from(state.orders);
      updatedOrderList[action.activePersonNo] = action.updatedOrder;
      console.log(updatedOrderList);
      return { ...state, orders: updatedOrderList };
    case attendeeConstants.UPDATE_DISCOUNT:
      var updatedOrderList = Array.from(state.orders);
      updatedOrderList[action.activePersonNo].discounts = action.discounts;
      console.log(updatedOrderList);
      return { ...state, orders: updatedOrderList };

    case attendeeConstants.REMOVE_ORDER_BY_CONDITION:
      let condtionizedOrderList = Array.from(state.orders);
      let currOrder = condtionizedOrderList[state.activePersonNo];
      if (currOrder.orderRow === undefined) return state;
      currOrder.orderRow = currOrder.orderRow.filter((or) => or.eventId !== action.eventId);
      return { ...state, orders: condtionizedOrderList };

    case attendeeConstants.SET_PAYMETHOD:
      return { ...state, payMethod: action.payMethod };

    default:
      return state;
  }
}
